import styled from '@emotion/styled'

import { colors } from 'Constants'

import { Grid } from 'lese'

export default styled(Grid)`
  padding: 8px 16px;
  border-bottom: 1px solid ${colors.background800};
  ${props => props.selected && `background-color: ${colors.background800}`};
  cursor: pointer;
  :hover {
    background-color: ${colors.background800};
  }
  ${({ isSelected }) => isSelected && `background-color: ${colors.background800};`}
`
